import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DateRangeFields,
  GET,
  POST,
  GET_FILE,
  saveAs,
  profile,
  t,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { fmtDate, fmtDateTime, pruneParams, hasPermission } from "../../utils/timeTracking.js";
import { readDepartmentFilter, departmentFilterOptions, departmentFilterValue, departmentFilterPatch, EMPTY_DEPARTMENT_FILTER } from "../../utils/departmentFilter.js";
import "../../assets/css/warranty-expiry.css";
import "../../assets/css/filter-alert-w5.css";
import { formatNumber } from "../../utils/formatting";

const PAGE_SIZE = 50;
const Q_DEBOUNCE_MS = 400;
const BUCKETS = ["ovd", "d7", "d30", "d60", "d90"];
const FOLLOWUP_FILTERS = ["all", "open", "call", "none", "callback", "unreach", "wr"];
const DEFAULT_CALLBACK = { min: 1, max: 90, default: 7 };
// ข้อความ 403 จาก backend เมื่อเปิด BU ที่ไม่มีสิทธิ์: "คุณไม่มีสิทธิ์ดูแผนก <code>"
const NO_DEPARTMENT_PATTERN = "ไม่มีสิทธิ์ดูแผนก";
const BANNER_COLORS = {
  ovd: ["#F9DADA", "#A61B1B"],
  d7: ["#FDECEC", "#D64545"],
  d30: ["#FFEBDD", "#D9620B"],
  d60: ["#FFF4DC", "#B86E0A"],
  d90: ["#E8EDFF", "#2643B8"],
  ok: ["#E3F5EA", "#1F8A4C"],
};

// ตัวเลขในข้อความใส่ , ทุกจุด (จำนวนเครื่อง / วันที่เลยกำหนด)
const fill = (text, values) => Object.keys(values).reduce((acc, k) => acc.replace(`{${k}}`, typeof values[k] === "number" ? formatNumber(values[k]) : values[k]), text);

// "YYYY-MM-DD" + n วัน (คำนวณแบบ UTC กันเลื่อนตาม timezone)
const addDays = (iso, n) => {
  const [y, m, d] = String(iso || "").slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "";
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
};

// หน้า "กำหนดเปลี่ยนไส้กรอง" (ทุกแผนกตามสิทธิ์) - field ตรงกับ SNAPA-Backend modules/admin/filter-alert
//   GET  admin/filter-alert                     -> data={rows,kpi,meta} + pagination (กรองด้วย department_uid / bu_code ได้ทุกแผนก)
//   GET  admin/filter-alert/:asset_uid          -> row + calculation + changes + followup_logs + alerts + wr_prefill + actions
//   POST admin/filter-alert/:asset_uid/followup -> {row, warnings, wr_prefill}
//   GET  admin/filter-alert/export              -> xlsx (GET_FILE)
// ลิงก์จากอีเมล: ?bu=BU06&open=<asset uid> -> กรอง BU + เปิด Modal เครื่องนั้น · ?department_uid=<uid> กรองแผนก
// เลือก "นัดหมายได้ → สร้าง WR" แล้วกดปุ่ม = ยังไม่บันทึก เปิด /ad/work-requests?prefill=1&department_uid&customer_uid&asset_uid&category_uid&followup_uid (BR-F7)
//   หน้า WR ยิง POST admin/filter-alert/:uid/followup {result:"wr", wr_uid} เองหลังสร้าง WR สำเร็จ (ยกเลิก/ปิดหน้า = ไม่บันทึก)
export default class AdminFilterAlert extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(window.location.search);
    this.initial_open = query.get("open") || "";
    const bucket = query.get("bucket");
    this.canExport = hasPermission(profile, "filter_alert.export");
    this.canFollowup = hasPermission(profile, "filter_alert.followup");
    this.q_timer = null;
    this.state = {
      ...readDepartmentFilter(query),
      filter_followup: "all", // เปิดหน้ามาเป็น "ทั้งหมด" (คอมเมนต์ 29/10 การ์ด dm7FIZ7i)
      filter_cycle: "",
      filter_q: "",
      filter_from: "",
      filter_to: "",
      filter_bucket: BUCKETS.includes(bucket) ? bucket : "",
      // ค่าเริ่มต้น "status" = เรียงตามสถานะติดตาม แล้วตามวันครบกำหนด (backend) · กดหัวคอลัมน์ = เรียงตามคอลัมน์นั้น
      sort_by: "status",
      sort_dir: "asc",

      rows: [],
      kpi: null,
      meta: null,
      count: 0,
      page: 1,
      loaded: false,
      forbidden: "",

      detail: null,
      form: null, // { result, callback_days, note }
      form_error: "",
      warnings: [],
      saving: false,
    };
  }

  componentDidMount() {
    loading(false);
    this.Get(1).then(() => {
      if (this.initial_open) this.OpenDetail(this.initial_open);
    });
  }

  componentWillUnmount() {
    clearTimeout(this.q_timer);
  }

  buildParams = () => {
    const { filter_bu, filter_department_uid, filter_followup, filter_cycle, filter_q, filter_from, filter_to, filter_bucket, sort_by, sort_dir } = this.state;
    return pruneParams({
      bu_code: filter_bu,
      department_uid: filter_department_uid,
      followup_status: filter_followup,
      cycle: filter_cycle,
      q: filter_q.trim(),
      from_date: filter_from,
      to_date: filter_to,
      bucket: filter_bucket,
      sort_by,
      sort_dir,
    });
  };

  Get = async (page = 1) => {
    const { filter_from, filter_to } = this.state;
    if (filter_from && filter_to && filter_from > filter_to) {
      alert("", "warning", t("warning"), t("nsp_range_invalid"));
      this.setState({ rows: [], kpi: null, count: 0, page: 1, loaded: true });
      return;
    }
    loading(true);
    const result = await GET("admin/filter-alert", { ...this.buildParams(), page, limit: PAGE_SIZE });
    loading(false);
    if (result?.status) {
      const rows = result.data?.rows || [];
      this.setState({
        rows,
        kpi: result.data?.kpi || null,
        meta: result.data?.meta || null,
        count: result.pagination?.count ?? rows.length,
        page,
        loaded: true,
        forbidden: "",
      });
      return;
    }
    const message = result?.message || "";
    this.setState({
      rows: [],
      kpi: null,
      count: 0,
      page: 1,
      loaded: true,
      forbidden: typeof message === "string" && message.includes(NO_DEPARTMENT_PATTERN) ? message : "",
    });
  };

  SetFilter = (patch) => this.setState(patch, () => this.Get(1));

  SetQ = (value) => {
    this.setState({ filter_q: value });
    clearTimeout(this.q_timer);
    this.q_timer = setTimeout(() => this.Get(1), Q_DEBOUNCE_MS);
  };

  ToggleBucket = (key) => this.SetFilter({ filter_bucket: this.state.filter_bucket === key ? "" : key });

  ResetFilter = () => {
    window.history.replaceState(null, "", window.location.pathname);
    this.SetFilter({ ...EMPTY_DEPARTMENT_FILTER, filter_followup: "all", filter_cycle: "", filter_q: "", filter_from: "", filter_to: "", filter_bucket: "" });
  };

  SortBy = (field) => {
    const { sort_by, sort_dir } = this.state;
    this.SetFilter({ sort_by: field, sort_dir: sort_by === field && sort_dir === "asc" ? "desc" : "asc" });
  };

  Export = async () => {
    const { filter_from, filter_to } = this.state;
    if (filter_from && filter_to && filter_from > filter_to) {
      alert("", "warning", t("warning"), t("nsp_range_invalid"));
      return;
    }
    loading(true);
    const result = await GET_FILE("admin/filter-alert/export", this.buildParams());
    loading(false);
    if (result?.status && result.blob) {
      saveAs(result.blob, result.fileName || "Filter_Replacement_Due.xlsx");
    } else {
      alert("", "warning", t("warning"), result?.message || t("wx_export_failed"));
    }
  };

  // keep = true เมื่อโหลดซ้ำหลังบันทึก (คงแผง WR/คำเตือนไว้)
  OpenDetail = async (uid, keep = false) => {
    loading(true);
    const result = await GET(`admin/filter-alert/${uid}`);
    loading(false);
    if (!result?.status || !result.data) return;
    const cb = result.data.actions?.callback_days || DEFAULT_CALLBACK;
    this.setState((prev) => ({
      detail: result.data,
      form: { result: "", callback_days: String(cb.default), note: "" },
      form_error: "",
      warnings: keep ? prev.warnings : [],
    }));
  };

  CloseDetail = () => {
    const query = new URLSearchParams(window.location.search);
    if (query.has("open")) {
      query.delete("open");
      const qs = query.toString();
      window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""));
    }
    this.setState({ detail: null, form: null, warnings: [], form_error: "" });
  };

  SaveFollowup = async () => {
    const { detail, form } = this.state;
    const cb = detail.actions?.callback_days || DEFAULT_CALLBACK;
    if (!form.result) return this.setState({ form_error: t("fa_fu_pick_result") });
    const days = Number(form.callback_days);
    if (form.result === "callback" && !(Number.isInteger(days) && days >= cb.min && days <= cb.max)) {
      return this.setState({ form_error: fill(t("fa_fu_days_range"), { min: cb.min, max: cb.max }) });
    }

    // นัดหมายได้ -> ยังไม่บันทึกอะไร ไปหน้า Work Request ก่อน หน้านั้นจะบันทึกผล (พร้อมเลข WR) เองหลังสร้างสำเร็จเท่านั้น
    if (form.result === "wr") {
      this.OpenWrPage(detail.wr_prefill || {}, detail);
      return;
    }

    this.setState({ saving: true, form_error: "" });
    loading(true);
    const result = await POST(`admin/filter-alert/${detail.uid}/followup`, {
      result: form.result,
      callback_days: form.result === "callback" ? days : undefined,
      note: form.note.trim() || undefined,
    });
    loading(false);
    this.setState({ saving: false });
    if (!result?.status) {
      this.setState({ form_error: (typeof result?.message === "string" && result.message) || t("wx_load_failed") });
      return;
    }
    const data = result.data || {};
    this.setState({ warnings: data.warnings || [] });
    alert("", "success", t("success"), t("fa_fu_saved"));
    await this.OpenDetail(detail.uid, true);
    this.Get(this.state.page);
  };

  OpenWrPage = (prefill, detail) => {
    const params = new URLSearchParams({ prefill: "1" });
    const values = {
      department_uid: prefill.department_uid || detail.department?.uid,
      customer_uid: prefill.customer_uid || detail.customer?.uid,
      asset_uid: prefill.asset_uid || detail.asset?.uid,
      category_uid: prefill.category_uid,
      // หมวดเปลี่ยนไส้กรองของ BU นี้ (หน้า WR ใช้หาหมวดเองเมื่อไม่มี category_uid) · BU07 = HQW ที่เหลือ = HHU
      category_token: detail.bu_code === "BU07" ? "HQW" : "HHU",
      // หน้า WR ใช้ยิงบันทึกผลติดตามกลับมาหลังสร้าง WR สำเร็จ
      followup_uid: detail.uid,
    };
    Object.keys(values).forEach((k) => values[k] && params.set(k, values[k]));
    window.location.href = `/ad/work-requests?${params.toString()}`;
  };

  // หน้า Assets รับ ?uid=<asset uid> เปิดรายละเอียดเครื่องนั้น (แท็บใหม่)
  OpenAssetPage = (asset) => window.open(`/ad/assets?uid=${encodeURIComponent(asset.uid)}`, "_blank", "noopener");

  // ---------------------------------------------------------------- render
  renderDays = (row) => {
    const label = row.days_left < 0 ? fill(t("fa_overdue_days"), { n: -row.days_left }) : fill(t("wx_days_left"), { n: row.days_left });
    return <span className={`d-inline-block text-12 fw-semibold px-2 py-1 rounded-pill text-nowrap wx-t-${row.bucket || "ok"}`}>{label}</span>;
  };

  // สถานะติดตาม: ให้โทรใหม่ที่ถึงวันแล้ว = สีแดง + ⏰ · ติดต่อไม่ได้ = ป้าย "พยายามแล้ว n ครั้ง" · สร้าง WR แล้ว = เลข WR + สถานะ WR
  renderFollowup = (fu, withDetail) => {
    if (!fu) return "-";
    const callDue = fu.status === "callback" && fu.is_call_due;
    return (
      <span>
        <span className={`fw-semibold ${callDue ? "wx-fu-none" : `wx-fu-fa-${fu.status}`}`}>{fu.label || t(`fa_fu_${fu.status}`)}</span>
        {fu.status === "callback" && fu.callback_date ? (
          <div className={`text-12 ${callDue ? "fw-semibold wx-fu-none" : "text-secondary"}`} data-testid={callDue ? "fa-call-due-tag" : undefined}>
            {callDue ? `⏰ ${t("fa_call_due_on")}` : t("fa_callback_on")} {fmtDate(fu.callback_date)}
          </div>
        ) : null}
        {fu.status === "unreach" && fu.unreach_count > 0 ? <div className="text-12 fw-semibold wx-fu-warn" data-testid="fa-attempts">{fill(t("fa_attempts"), { n: fu.unreach_count })}</div> : null}
        {fu.status === "wr" && fu.wr?.number ? (
          <div className="text-secondary text-12">{fu.wr.number}{withDetail && fu.wr.status_label ? ` · ${fu.wr.status_label}` : ""}</div>
        ) : null}
      </span>
    );
  };

  renderKpi() {
    const { kpi, filter_bucket } = this.state;
    if (!kpi) return null;
    const card = (key, value, label, extra, onClick, testid) => (
      <div className="col-6 col-md-4 col-xl-2" key={key || "total"}>
        <button type="button" className={`fa2-kpi ${extra} rounded-4 shadow-sm p-3 h-100 ${filter_bucket === key ? "on" : ""}`} onClick={onClick} data-testid={testid}>
          <div className="text-secondary text-14 fw-bold text-truncate" title={label}>{label}</div>
          <div className="v">{formatNumber(value)}</div>
        </button>
      </div>
    );
    return (
      <div className="row g-3 mb-4" data-testid="fa-kpis">
        {card("", kpi.total, t("fa_kpi_all"), "total", () => this.SetFilter({ filter_bucket: "" }), "fa-kpi-total")}
        {BUCKETS.map((b) => card(b, kpi[b], t(`fa_bucket_${b}`), b, () => this.ToggleBucket(b), `fa-kpi-${b}`))}
      </div>
    );
  }

  renderSortTh = (field, label, className) => {
    const { sort_by, sort_dir } = this.state;
    return (
      <th className={`border-0 wx-th-sort ${className || ""}`} onClick={() => this.SortBy(field)}>
        {label} {sort_by === field ? (sort_dir === "asc" ? "▲" : "▼") : ""}
      </th>
    );
  };

  renderTable() {
    const { rows } = this.state;
    return (
      <div className="table-responsive">
        <table className="table table-hover align-middle mb-0 fa2-table">
          <thead>
            <tr className="text-dark fw-bold border-bottom border-light">
              {this.renderSortTh("days_left", t("fa_col_days"), "nw")}
              {this.renderSortTh("department", t("department"), "nw")}
              {this.renderSortTh("asset_code", t("fa_col_asset"))}
              {this.renderSortTh("customer_name", t("wx_col_customer"))}
              <th className="border-0">{t("fa_col_machine")}</th>
              <th className="border-0">{t("fa_col_last_change")}</th>
              {this.renderSortTh("cycle_months", t("fa_col_cycle"), "text-end nw")}
              {this.renderSortTh("due_date", t("fa_col_due"), "nw")}
              <th className="border-0">{t("wx_col_followup")}</th>
              <th className="border-0">{t("fa_col_last_log")}</th>
              <th className="border-0" />
            </tr>
          </thead>
          <tbody>
            {!rows.length ? (
              <tr>
                <td colSpan={11} className="text-center text-secondary py-5">
                  {t("fa_empty")}
                  <div><ClearFilterButton className="mt-2" onClick={this.ResetFilter} /></div>
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.uid} className="border-bottom border-light bg-white pointer" onClick={() => this.OpenDetail(r.uid)} data-testid="fa-row">
                  <td className="nw">{this.renderDays(r)}</td>
                  <td className="nw fw-bold text-dark">{[r.department?.code, r.department?.name].filter(Boolean).join(" ") || "-"}</td>
                  <td className="ref">{r.asset?.code || "-"}</td>
                  <td className="wrap text-dark">{r.customer_name || "-"}<div className="sub">{r.location || ""}</div></td>
                  <td className="wrap text-dark">{r.asset?.name || "-"}<div className="sub">{r.asset?.serial ? `${t("wx_serial")} ${r.asset.serial}` : ""}</div></td>
                  <td className="nw text-dark">
                    {r.last_change_date ? fmtDate(r.last_change_date) : (
                      <>
                        <span className="text-12 fw-semibold px-2 py-1 rounded-pill wx-t-exp">{t("fa_install")}</span> {fmtDate(r.install_date || r.base_date)}
                      </>
                    )}
                  </td>
                  <td className="text-dark text-end">{r.cycle_months}</td>
                  <td className="nw fw-bold text-dark">{fmtDate(r.due_date)}</td>
                  <td className="wrap">{this.renderFollowup(r.followup)}</td>
                  <td className="nw sub">
                    {r.followup?.last_log ? (
                      <>{fmtDateTime(r.followup.last_log.created_at)}{r.followup.last_log.created_by_name ? <div>{r.followup.last_log.created_by_name}</div> : null}</>
                    ) : "—"}
                  </td>
                  <td className="nw">
                    <button type="button" className="btn btn-white border border-primary text-primary px-3 py-1 rounded-3 text-12" onClick={(e) => { e.stopPropagation(); this.OpenDetail(r.uid); }} data-testid="fa-follow-btn">{t("fa_follow")}</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderFollowupForm() {
    const { detail, form, form_error, saving } = this.state;
    const actions = detail.actions || {};
    const cb = actions.callback_days || DEFAULT_CALLBACK;
    const setForm = (patch) => this.setState({ form: { ...form, ...patch }, form_error: "" });
    // ผลติดตาม "สร้าง WR" ต้องมีสิทธิ์สร้างใบคำร้อง (wr.create)
    const results = (actions.results || []).map((r) => r.key).filter((key) => key !== "wr" || can("wr.create"));
    const days = Number(form.callback_days);
    const daysOk = Number.isInteger(days) && days >= cb.min && days <= cb.max;
    const callbackDate = daysOk ? addDays(detail.as_of, days) : "";
    const afterDue = callbackDate && detail.due_date && callbackDate > String(detail.due_date).slice(0, 10);

    if (!actions.can_followup) {
      return (
        <div className="text-secondary text-14 mb-4" data-testid="fa-fu-closed">
          <div className="text-14 fw-bold text-dark mb-2">{t("fa_fu_title")}</div>
          {actions.blocked_reason || t("fa_fu_closed")}
        </div>
      );
    }
    if (!this.canFollowup) {
      return (
        <div className="mb-4">
          <div className="text-14 fw-bold text-dark mb-2">{t("fa_fu_title")}</div>
          <div className="text-secondary text-12">{t("wx_fu_readonly")}</div>
        </div>
      );
    }
    return (
      <>
        <div className="text-14 fw-bold text-dark mb-1">📞 {t("fa_fu_title")}</div>
        <div className="text-secondary text-12 mb-2">{t("fa_fu_hint")}</div>
        <div className="border rounded-3 p-3 mb-4" data-testid="fa-fu-form">
          <div className="d-flex flex-column gap-1 mb-3">
            {results.map((key) => (
              <div key={key}>
                <div className="form-check">
                  <label className="form-check-label text-14 text-dark">
                    <input className="form-check-input" type="radio" name="fa-result" checked={form.result === key} onChange={() => setForm({ result: key })} data-testid={`fa-result-${key}`} />
                    {t(`fa_result_${key}`)}
                  </label>
                </div>
                {key === "callback" && form.result === "callback" ? (
                  <div className="ms-4 my-2 d-flex align-items-center flex-wrap gap-2" data-testid="fa-callback-box">
                    <input type="number" className="form-control" style={{ width: 90 }} min={cb.min} max={cb.max} value={form.callback_days} onChange={(e) => setForm({ callback_days: e.target.value })} data-testid="fa-callback-days" />
                    <span className="text-14 text-dark">{t("fa_days")}</span>
                    <span className="text-secondary text-12">→ {t("fa_callback_on")} <b className="text-dark">{callbackDate ? fmtDate(callbackDate) : "-"}</b></span>
                    {afterDue ? <span className="text-12 fw-semibold wx-fu-warn" data-testid="fa-callback-warn">⚠️ {fill(t("fa_callback_after_due"), { date: fmtDate(detail.due_date) })}</span> : null}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
          <label className="form-label text-12 text-secondary mb-1">{t("wx_fu_note")}</label>
          <textarea className="form-control" rows={2} value={form.note} placeholder={t("fa_fu_note_ph")} onChange={(e) => setForm({ note: e.target.value })} data-testid="fa-fu-note" />
          {form_error ? <div className="mt-1 text-danger text-12" data-testid="fa-fu-error">{form_error}</div> : null}
          <div className="d-flex justify-content-end mt-3">
            <button type="button" className="btn btn-primary px-4 py-2 fw-bold rounded-3" disabled={saving} onClick={this.SaveFollowup} data-testid="fa-fu-save">
              {form.result === "wr" ? `${t("fa_fu_save_wr")} →` : t("fa_fu_save")}
            </button>
          </div>
        </div>
      </>
    );
  }

  renderDetailModal() {
    const { detail, warnings } = this.state;
    const bucket = detail?.bucket || "ok";
    const banner = !detail
      ? ""
      : detail.days_left < 0
        ? `⛔ ${fill(t("fa_d_banner_overdue"), { n: -detail.days_left })}`
        : detail.bucket
          ? `⏳ ${fill(t("fa_d_banner_left"), { n: detail.days_left })}`
          : `✅ ${fill(t("fa_d_banner_far"), { n: detail.days_left })}`;
    const colors = BANNER_COLORS[bucket] || BANNER_COLORS.ok;
    const calc = detail?.calculation;
    const logs = detail?.followup_logs || [];
    const changes = detail?.changes || [];
    const alerts = detail?.alerts || [];
    const kv = detail
      ? [
          [t("wx_d_customer"), detail.customer_name],
          [t("wx_d_location"), detail.location],
          [t("fa_d_address"), detail.location_address || "-"],
          [t("fa_d_contact"), detail.contact_name || "-"],
          [t("fa_d_phone"), detail.contact_phone || "-"],
          [t("fa_d_machine"), detail.asset?.name],
          [t("wx_d_serial_asset"), detail.asset?.serial],
          [t("fa_d_install"), detail.install_date ? fmtDate(detail.install_date) : "-"],
          [t("fa_d_status"), this.renderFollowup(detail.followup, true)],
        ]
      : [];

    return (
      <Modal show={!!detail} onHide={this.CloseDetail} centered size="lg" scrollable contentClassName="border-0 rounded-4 shadow-lg" data-testid="fa-drawer">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          {detail ? (
            <div>
              <div className="text-secondary text-12">🧪 {t("fa_menu_report")} · {[detail.bu_code || detail.department?.code, detail.bu_label || detail.department?.name].filter(Boolean).join(" – ")}</div>
              <h5 className="fw-bold mb-0 text-dark">{detail.asset?.code}</h5>
            </div>
          ) : null}
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
          {detail ? (
            <>
              <div className="rounded-3 p-3 mb-3 fw-semibold text-14" style={{ background: colors[0], color: colors[1] }}>
                {banner} · {t("fa_d_due")} {fmtDate(detail.due_date)}
              </div>

              {calc ? (
                <div className="rounded-3 p-3 mb-4" style={{ background: "#F4F7FE" }} data-testid="fa-calc">
                  <div className="text-secondary text-12 fw-bold mb-1">{t("fa_calc_title")}</div>
                  <div className="text-14 text-dark">
                    {t(calc.base_source === "last_change" ? "fa_calc_last_change" : "fa_calc_install")} <b>{fmtDate(calc.base_date)}</b> + {calc.cycle_months} {t("fa_months")} = <b>{fmtDate(calc.due_date)}</b>
                  </div>
                  <div className="text-secondary text-12">{fill(t("fa_calc_hint"), { n: calc.cycle_months })}</div>
                </div>
              ) : null}

              <div className="fa2-kv mb-4" data-testid="fa-kv">
                {kv.map(([label, value]) => (
                  <React.Fragment key={label}>
                    <div className="k">{label}</div>
                    <div className="val">{value || "-"}</div>
                  </React.Fragment>
                ))}
              </div>

              {warnings.map((w, i) => (
                <div className="alert alert-warning py-2 text-14 fw-semibold" key={`${w.code}-${i}`} data-testid="fa-warning">{w.message}</div>
              ))}
              {this.renderFollowupForm()}

              <div className="text-14 fw-bold text-dark mb-2">🗂️ {t("fa_log_title")} ({logs.length})</div>
              <div className="table-responsive border rounded-3 mb-4">
                <table className="table table-hover align-middle mb-0">
                  <thead>
                    <tr className="text-dark fw-bold text-12 border-bottom border-light">
                      <th className="py-2 border-0">{t("fa_log_at")}</th>
                      <th className="py-2 border-0">{t("fa_log_by")}</th>
                      <th className="py-2 border-0">{t("fa_log_result")}</th>
                      <th className="py-2 border-0">{t("fa_callback_on")}</th>
                      <th className="py-2 border-0">{t("wx_fu_note")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!logs.length ? (
                      <tr><td colSpan={5} className="text-secondary text-12">{t("fa_log_none")}</td></tr>
                    ) : logs.map((l) => (
                      <tr key={l.uid} className="text-14 text-dark" style={l.is_current_cycle ? undefined : { opacity: 0.6 }}>
                        <td>{fmtDateTime(l.created_at)}</td>
                        <td>{l.created_by_name || "-"}</td>
                        <td>
                          {l.result_label}
                          {l.wr?.number ? <div className="text-secondary text-12">{l.wr.number}</div> : null}
                          {l.wo?.number ? <div className="text-secondary text-12">{l.wo.number}</div> : null}
                          {l.is_current_cycle ? null : <div className="text-secondary text-12">{t("wx_alert_old_cycle")}</div>}
                        </td>
                        <td>{l.callback_date ? fmtDate(l.callback_date) : "-"}</td>
                        <td className="text-break">{l.note || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-14 fw-bold text-dark mb-2">🧾 {t("fa_changes_title")}</div>
              <div className="table-responsive border rounded-3 mb-4">
                <table className="table table-hover align-middle mb-0">
                  <thead>
                    <tr className="text-dark fw-bold text-12 border-bottom border-light">
                      <th className="py-2 border-0">{t("wx_h_no")}</th>
                      <th className="py-2 border-0">{t("fa_changes_date")}</th>
                      <th className="py-2 border-0">{t("fa_changes_tech")}</th>
                      <th className="py-2 border-0">WO / WR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!changes.length ? (
                      <tr><td colSpan={4} className="text-secondary text-12">{t("fa_changes_none")}</td></tr>
                    ) : changes.map((c) => (
                      <tr key={c.no} className="text-14 text-dark">
                        <td>
                          {c.no}
                          {c.used_for_calc ? <span className="text-12 fw-semibold text-primary bg-primary-light px-2 py-1 rounded-pill ms-1">{t("wx_h_used")}</span> : null}
                        </td>
                        <td>{fmtDate(c.changed_on)}</td>
                        <td>{c.technician_names || "-"}</td>
                        <td>{c.work_order?.number || "-"}{c.wr_number ? <div className="text-secondary text-12">{c.wr_number}</div> : null}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {detail.asset?.uid ? (
                <div className="d-flex justify-content-end mb-4">
                  <button type="button" className="btn btn-white border px-3 py-2 rounded-3 fw-bold" onClick={() => this.OpenAssetPage(detail.asset)} data-testid="fa-open-asset">{t("fa_open_asset")}</button>
                </div>
              ) : null}

              <div className="text-14 fw-bold text-dark mb-2">{t("wx_alert_history")}</div>
              <div className="wx-timeline">
                {!alerts.length ? <div className="it text-secondary">{t("wx_alert_none")}</div> : null}
                {alerts.map((a, i) => (
                  <div className="it text-dark" key={i}>
                    <b>{fmtDateTime(a.sent_at)}</b> — {fill(t("wx_alert_item"), { b: a.bucket })}
                  </div>
                ))}
              </div>
            </>
          ) : null}
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const { filter_bu, filter_followup, filter_cycle, filter_q, filter_from, filter_to, meta, count, page, rows, loaded, forbidden } = this.state;
    const cycles = meta?.cycle_options || [];
    const dq = meta?.data_quality;
    const followupOptions = FOLLOWUP_FILTERS.map((f) => ({ value: f, label: t(`fa_f_${f}`) }));
    const asOf = meta?.data_as_of ? fmtDateTime(meta.data_as_of) : meta?.as_of ? fmtDate(meta.as_of) : "";

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          <div className="d-flex justify-content-between align-items-start mb-4 gap-3">
            <div style={{ minWidth: 0 }}>
              <h3 className="fw-bold mb-1 text-dark">{t("fa_title")}</h3>
              <div className="text-secondary text-14" data-testid="fa-as-of">{asOf ? `${t("wx_as_of")} ${asOf} · ` : ""}{t("fa_desc_bu")}</div>
            </div>
            {this.canExport && !forbidden ? (
              <button type="button" className="btn btn-success border-0 px-4 py-2 fw-bold rounded-3 text-nowrap" onClick={this.Export} disabled={!rows.length} data-testid="fa-export-btn">{t("wx_export")}</button>
            ) : null}
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-6 col-lg-3" data-testid="fa-f-bu">
                <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
                <Select
                  className="form-control w-100"
                  options={departmentFilterOptions(meta, filter_bu, t("wx_f_all_departments"))}
                  value={departmentFilterValue(this.state)}
                  onChange={(v) => this.SetFilter(departmentFilterPatch(v))}
                  placeholder={t("wx_f_all_departments")}
                />
              </div>
              <div className="col-md-6 col-lg-2" data-testid="fa-f-followup">
                <label className="form-label text-12 text-secondary mb-1">{t("wx_f_followup")}</label>
                <Select
                  className="form-control w-100"
                  options={followupOptions}
                  value={filter_followup}
                  onChange={(v) => this.SetFilter({ filter_followup: v || "all" })}
                  placeholder={t("fa_f_all")}
                  default={false}
                />
              </div>
              <div className="col-md-4 col-lg-2">
                <label className="form-label text-12 text-secondary mb-1">{t("fa_f_cycle")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("fa_f_cycle_all") }, ...cycles.map((c) => ({ value: String(c), label: fill(t("fa_f_cycle_n"), { n: c }) }))]}
                  value={String(filter_cycle)}
                  onChange={(v) => this.SetFilter({ filter_cycle: v || "" })}
                  placeholder={t("fa_f_cycle_all")}
                />
              </div>
              <div className="col-md-8 col-lg-3">
                <label className="form-label text-12 text-secondary mb-1">{t("wx_f_search")}</label>
                <input type="text" className="form-control" value={filter_q} placeholder={t("fa_f_search_ph")} onChange={(e) => this.SetQ(e.target.value)} />
              </div>
              <div className="col-md-6 col-lg-4" data-testid="fa-f-date">
                <label className="form-label text-12 text-secondary mb-1">{t("fa_f_due_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type="th"
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_from}
                    endValue={filter_to}
                    onChange={({ start, end }) => this.SetFilter({ filter_from: start, filter_to: end })}
                  />
                </div>
              </div>
              <div className="col-auto ms-lg-auto">
                <ClearFilterButton onClick={this.ResetFilter} data-testid="fa-clear" />
              </div>
            </div>
          </div>

          {forbidden ? (
            <div className="bg-white rounded-4 shadow-sm p-5 mb-4 text-center" data-testid="fa-forbidden">
              <h4 className="fw-bold text-dark">{forbidden}</h4>
              <p className="text-secondary text-14 mb-3">{t("wx_no_permission_hint")}</p>
              <button type="button" className="btn btn-primary px-4 py-2 fw-bold rounded-3" onClick={this.ResetFilter}>{t("wx_f_all_departments")}</button>
            </div>
          ) : (
            <>
              {dq && dq.excluded_total > 0 ? (
                <div className="alert alert-warning text-14 py-2 mb-4" data-testid="fa-dq">
                  {fill(t("fa_dq"), { n: dq.excluded_total, a: dq.missing_cycle ?? 0, b: dq.missing_base_date ?? 0 })}
                </div>
              ) : null}

              {this.renderKpi()}

              <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 px-4 pt-3 text-12 text-secondary">
                  <span>
                    {fill(t("fa_shown"), { n: count })}
                    {" · "}
                    <button type="button" className="btn btn-link p-0 text-12 fw-semibold align-baseline" onClick={() => this.SetFilter({ filter_followup: "call" })} data-testid="fa-call-due">📞 {fill(t("fa_call_due_link"), { n: meta?.call_due_count ?? 0 })}</button>
                  </span>
                  <span>{t("fa_sort_hint")}</span>
                </div>
                {loaded ? this.renderTable() : null}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                <div>
                  {t("showing")} {count ? (page - 1) * PAGE_SIZE + 1 : 0}-{(page - 1) * PAGE_SIZE + rows.length} {t("of")} {formatNumber(count)}
                </div>
                <Pagination className="mb-0" count={Math.ceil(count / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, next) => this.Get(next)} />
              </div>
            </>
          )}
        </div>

        {this.renderDetailModal()}
      </div>
    );
  }
}
